import React from 'react';
import LoginRegister from '../components/LoginRegister/login_register';

function RegisterPage() {
  return <LoginRegister mode="register" />;
}

export default RegisterPage;
